import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker, Modal, HeaderTitle } from 'components';
import { ProfileService, AuthService, ApiIntegrationService } from 'services';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { RouteComponentProps } from 'react-router-dom';
import { CopyIcon, CloseRedIcon, FacebookIcon, WhatsappIcon, InstagramIcon, CheckGreenCircle, TiktokIcon, GoogleCalendarIcon, InstagramIcon2, FacebookMessengerIcon2, WhatsappIcon2, GoogleCalendarIcon2, ApiIcon2 } from 'assets/icons';
import { WhiteImage } from 'assets/img';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import queryString from 'query-string';
import { useGoogleLogin } from '@react-oauth/google';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const TYPES = {
	FACEBOOK: 1,
	INSTAGRAM: 2,
	WHATSAPP: 3,
	TIKTOK: 4,
	GOOGLE_CALENDAR: 5
}

class Api extends React.Component<Props> {

	timer: any = undefined;

	state = {
		user: null,
		copied: false,
		bearer_token: '',
		visible_api: false,
		redirect_url: null,
		instagram_client_id: null,
		facebook_client_id: null,
		instagram_name: null,
		facebook_name: null,
		accounts: [],
		visible_modal: false,
		visible_business_modal: false,
		visible_whatsapp_modal: false,
		visible_facebook_business_modal: false,
		account_selected_id: null,
		whatsapp_number: null,
		whatsapp_business_accounts: [],
		whatsapp_accounts: [],
		business_selected_id: null,
		whatsapp_selected_id: null,
		facebook_business_accounts: [],
		facebook_business_id: null,
		tiktok_client_id: null,
		code_challenge: null,
		tiktok_name: null,
		google_calendar_email: null,
		form: {
			search: ''
		}
	}

	async componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Conexión de Canales',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await ProfileService.get({
			withoutLoading
		});
		this.setState({
			user: res.user,
			bearer_token: res.user?.bearer_token || '',
			instagram_client_id: res.instagram_client_id || null,
			facebook_client_id: res.facebook_client_id || null,
			redirect_url: res.redirect_url || null,
			instagram_name: res.instagram_name || null,
			facebook_name: res.facebook_name || null,
			whatsapp_number: res.whatsapp_number || null,
			tiktok_client_id: res.tiktok_client_id || null,
			code_challenge: res.code_challenge || null,
			tiktok_name: res.tiktok_name || null,
			google_calendar_email: res.google_calendar_email || null
		},() => {
			if (this.props.location?.search) {
				const params = queryString.parse(this.props.location?.search);

				if (params?.success_facebook) {
					Globals.showSuccess("Se ha conectado el Facebook correctamente");
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.success_instagram) {
					Globals.showSuccess("Se ha conectado el Instagram correctamente");
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.success_whatsapp) {
					Globals.showSuccess("Se ha conectado el Whatsapp correctamente");
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.success_tiktok) {
					Globals.showSuccess("Se ha conectado el Tiktok correctamente");
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.facebook_accounts) {
					// @ts-ignore
					const accounts = JSON.parse(params?.facebook_accounts);

					this.setState({
						accounts,
						visible_modal: true
					});
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.whatsapp_business_accounts) {
					// @ts-ignore
					const whatsapp_business_accounts = JSON.parse(params?.whatsapp_business_accounts);

					this.setState({
						whatsapp_business_accounts,
						visible_business_modal: true
					});
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.whatsapp_accounts) {
					// @ts-ignore
					const whatsapp_accounts = JSON.parse(params?.whatsapp_accounts);

					this.setState({
						whatsapp_accounts,
						visible_whatsapp_modal: true
					});
					this.props.history.replace({
				        search: ''
				    });
				}
				else if (params?.facebook_business_accounts) {
					// @ts-ignore
					const facebook_business_accounts = JSON.parse(params?.facebook_business_accounts);

					this.setState({
						facebook_business_accounts,
						visible_facebook_business_modal: true
					});
					this.props.history.replace({
				        search: ''
				    });
				}
			}
		});
	}

	generateToken = () => {
		Globals.confirm('Si genera una nueva llave, la actual dejara de funcionar. ¿Desea continuar?',async () => {
			const res: any = await ProfileService.generateToken();
			if (res.user) {
				this.setState({
					bearer_token: res.user?.bearer_token
				});
			}
			Globals.showSuccess("Se ha generado una nueva llave");
			this.load(true);
		});
	}
	
	connect = async (type: number) => {
		switch(type) {
			case TYPES.FACEBOOK:
				window.location.replace(`https://www.facebook.com/v23.0/dialog/oauth?client_id=${ this.state.facebook_client_id }&redirect_uri=${ this.state.redirect_url + 'facebook' }&config_id=${ process.env.REACT_APP_FACEBOOK_CONFIG }&state=${ this.props.access_token }&response_type=code`);
			break;

			case TYPES.INSTAGRAM:
				window.location.replace(`https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${ this.state.instagram_client_id }&redirect_uri=${ this.state.redirect_url + 'instagram' }&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights&state=${ this.props.access_token }`);
			break;

			case TYPES.WHATSAPP:
				window.location.replace(`https://www.facebook.com/v23.0/dialog/oauth?client_id=${ this.state.facebook_client_id }&redirect_uri=${ this.state.redirect_url + 'whatsapp' }&config_id=${ process.env.REACT_APP_WHATSAPP_CONFIG }&state=${ this.props.access_token }&response_type=code&&scope=whatsapp_business_messaging`);
			break;

			case TYPES.TIKTOK:
				window.location.replace(`https://business-api.tiktok.com/portal/auth?app_id=${ this.state.tiktok_client_id }&state=${ this.props.access_token }&redirect_uri=${ process.env.REACT_APP_TIKTOK_URL }`);
			break;
		}
	}

	disconnect = (type: number) => {
		switch(type) {
			case TYPES.FACEBOOK:
				Globals.confirm('¿Desconectar Facebook?',async () => {
				  await ApiIntegrationService.deleteFacebook();
			      Globals.showSuccess("Se ha desconectado el Facebook correctamente");
			      this.load(true);
				});
			break;

			case TYPES.INSTAGRAM:
				Globals.confirm('¿Desconectar Instagram?',async () => {
				  await ApiIntegrationService.deleteInstagram();
			      Globals.showSuccess("Se ha desconectado el Instagram correctamente");
			      this.load(true);
				});
			break;

			case TYPES.WHATSAPP:
				Globals.confirm('¿Desconectar Whatsapp?',async () => {
				  await ApiIntegrationService.deleteWhatsapp();
			      Globals.showSuccess("Se ha desconectado el Whatsapp correctamente");
			      this.load(true);
				});
			break;

			case TYPES.TIKTOK:
				Globals.confirm('¿Desconectar Tiktok?',async () => {
				  await ApiIntegrationService.deleteTiktok();
			      Globals.showSuccess("Se ha desconectado el Tiktok correctamente");
			      this.load(true);
				});
			break;
		}
	}

	showApi = () => {
		this.setState({
			visible_api: !this.state.visible_api
		});	
	}

	onClose = () => {
		this.setState({
			visible_modal: false,
			account_selected_id: null,
			accounts: []
		});
	}

	onCloseBusiness = () => {
		this.setState({
			visible_business_modal: false,
			business_selected_id: null,
			whatsapp_business_accounts: []
		});
	}

	onCloseWhatsapp = () => {
		this.setState({
			visible_whatsapp_modal: false,
			whatsapp_selected_id: null,
			whatsapp_accounts: []
		});
	}

	onCloseFacebookBusiness = () => {
		this.setState({
			visible_facebook_business_modal: false,
			facebook_business_id: null,
			facebook_business_accounts: []
		});
	}

	submitSelectAccount = async () => {
		if (!this.state.account_selected_id) {
			Globals.showError("Por favor, seleccione la página a conectar");
			return;
		}

		await ApiIntegrationService.finalizeFacebook({
			facebook_id: this.state.account_selected_id
		});
		this.setState({
			visible_modal: false,
			account_selected_id: null,
			accounts: []
		},() => {
			Globals.showSuccess("Se ha conectado el Facebook correctamente");
			this.load(true);
		});
	}

	submitFacebookBusiness = async () => {
		if (!this.state.facebook_business_id) {
			Globals.showError("Por favor, seleccione la aplicación a conectar");
			return;
		}

		const res: any = await ApiIntegrationService.finalizeFacebookBusiness({
			facebook_business_id: this.state.facebook_business_id
		});
		this.setState({
			visible_facebook_business_modal: false,
			facebook_business_id: null,
			facebook_business_accounts: []
		},() => {
			if (res?.whatsapp_business_accounts) {
				this.setState({
					whatsapp_business_accounts: res.whatsapp_business_accounts,
					visible_business_modal: true
				});
			}
			else {
				Globals.showSuccess("Se ha conectado la aplicación correctamente");
				this.load(true);
			}
		});
	}

	submitWhatsapp = async () => {
		if (!this.state.whatsapp_selected_id) {
			Globals.showError("Por favor, seleccione el número a conectar");
			return;
		}

		await ApiIntegrationService.finalizeWhatsapp({
			whatsapp_id: this.state.whatsapp_selected_id
		});
		this.setState({
			visible_whatsapp_modal: false,
			whatsapp_selected_id: null,
			whatsapp_accounts: []
		},() => {
			Globals.showSuccess("Se ha conectado el Whatsapp correctamente");
			this.load(true);
		});
	}

	submitBusinessWhatsapp = async () => {
		if (!this.state.business_selected_id) {
			Globals.showError("Por favor, seleccione la cuenta de empresa a conectar");
			return;
		}

		const res: any = await ApiIntegrationService.finalizeBusinessWhatsapp({
			business_id: this.state.business_selected_id
		});
		this.setState({
			visible_business_modal: false,
			business_selected_id: null,
			whatsapp_business_accounts: []
		},() => {
			if (res?.whatsapp_accounts) {
				this.setState({
					whatsapp_accounts: res.whatsapp_accounts,
					visible_whatsapp_modal: true
				});
			}
			else {
				Globals.showSuccess("Se ha conectado el Whatsapp correctamente");
				this.load(true);
			}
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	onCloseApi = () => {
		this.setState({
			visible_api: false
		});
	}

	render() {
		const user: any = this.state.user;
		const person = user?.person;
		const { visible_api, visible_modal, visible_business_modal, visible_whatsapp_modal, visible_facebook_business_modal } = this.state;
		const searchFilter = this.state.form.search.toLowerCase();

		return (
			<div id="client-api">
				<Modal
		          className="modal-select-facebook-account"
		          visible={ visible_modal }
		          title="Seleccionar página"
		          onClose={ () => this.onClose() }
		        >
		          <div id="modal-select-facebook-account">
		          	<p>Por favor, seleccione la página de facebook a conectar:</p>
		          	{
		          		this.state.accounts?.map((item: any) => {
		          			return (
		          				<a href="#" className="item-account" onClick={ (e: any) => {
		          					e.preventDefault();
		          					this.setState({
		          						account_selected_id: item.id
		          					});
		          				} }>
		          					<div className="check-container">
		          						<div className={ `check ${ this.state.account_selected_id == item.id ? 'active' : '' }` }></div>
		          					</div>
		          					<div style={{ flex: 1 }}>
		          						<p>{ item?.name }</p>
		          					</div>
		          				</a>
		          			)
		          		})
		          	}
		          	{
		          		this.state.accounts?.length == 0 && (
		          			<p className="no-items">No se han encontrado páginas de facebook</p>
		          		)
		          	}
		          	<div className="text-center">
						<Button type="submit" onClick={ this.submitSelectAccount }>
							Guardar
						</Button>
					</div>
		          </div>
		      	</Modal>

		      	<Modal
		          className="modal-select-facebook-account"
		          visible={ visible_business_modal }
		          title="Seleccionar cuenta de empresa"
		          onClose={ () => this.onCloseBusiness() }
		        >
		          <div id="modal-select-facebook-account">
		          	<p>Por favor, seleccione la cuenta de empresa a conectar:</p>
		          	{
		          		this.state.whatsapp_business_accounts?.map((item: any) => {
		          			return (
		          				<a href="#" className="item-account" onClick={ (e: any) => {
		          					e.preventDefault();
		          					this.setState({
		          						business_selected_id: item.id
		          					});
		          				} }>
		          					<div className="check-container">
		          						<div className={ `check ${ this.state.business_selected_id == item.id ? 'active' : '' }` }></div>
		          					</div>
		          					<div style={{ flex: 1 }}>
		          						<p>{ item?.name }</p>
		          					</div>
		          				</a>
		          			)
		          		})
		          	}
		          	{
		          		this.state.whatsapp_business_accounts?.length == 0 && (
		          			<p className="no-items">No se han encontrado cuentas de empresa</p>
		          		)
		          	}
		          	<div className="text-center">
						<Button type="submit" onClick={ this.submitBusinessWhatsapp }>
							Guardar
						</Button>
					</div>
		          </div>
		      	</Modal>

		      	<Modal
		          className="modal-select-facebook-account"
		          visible={ visible_whatsapp_modal }
		          title="Seleccionar número"
		          onClose={ () => this.onCloseWhatsapp() }
		        >
		          <div id="modal-select-facebook-account">
		          	<p>Por favor, seleccione la número a conectar:</p>
		          	{
		          		this.state.whatsapp_accounts?.map((item: any) => {
		          			return (
		          				<a href="#" className="item-account" onClick={ (e: any) => {
		          					e.preventDefault();
		          					this.setState({
		          						whatsapp_selected_id: item.id
		          					});
		          				} }>
		          					<div className="check-container">
		          						<div className={ `check ${ this.state.whatsapp_selected_id == item.id ? 'active' : '' }` }></div>
		          					</div>
		          					<div style={{ flex: 1 }}>
		          						<p className="bold">{ item?.name }</p>
		          						<p>{ item?.phone }</p>
		          					</div>
		          				</a>
		          			)
		          		})
		          	}
		          	{
		          		this.state.whatsapp_accounts?.length == 0 && (
		          			<p className="no-items">No se han encontrado números</p>
		          		)
		          	}
		          	<div className="text-center">
						<Button type="submit" onClick={ this.submitWhatsapp }>
							Guardar
						</Button>
					</div>
		          </div>
		      	</Modal>

		      	<Modal
		          className="modal-select-facebook-account"
		          visible={ visible_facebook_business_modal }
		          title="Seleccionar aplicación"
		          onClose={ () => this.onCloseFacebookBusiness() }
		        >
		          <div id="modal-select-facebook-account">
		          	<p>Por favor, seleccione la aplicación a conectar:</p>
		          	{
		          		this.state.facebook_business_accounts?.map((item: any) => {
		          			return (
		          				<a href="#" className="item-account" onClick={ (e: any) => {
		          					e.preventDefault();
		          					this.setState({
		          						facebook_business_id: item.id
		          					});
		          				} }>
		          					<div className="check-container">
		          						<div className={ `check ${ this.state.facebook_business_id == item.id ? 'active' : '' }` }></div>
		          					</div>
		          					<div style={{ flex: 1 }}>
		          						<p>{ item?.name }</p>
		          					</div>
		          				</a>
		          			)
		          		})
		          	}
		          	{
		          		this.state.facebook_business_accounts?.length == 0 && (
		          			<p className="no-items">No se han encontrado aplicaciones</p>
		          		)
		          	}
		          	<div className="text-center">
						<Button type="submit" onClick={ this.submitFacebookBusiness }>
							Guardar
						</Button>
					</div>
		          </div>
		      	</Modal>

		      	<Modal
		          className="modal-connect-api"
		          visible={ visible_api }
		          title="Conectar API"
		          onClose={ () => this.onCloseApi() }
		        >
		          <div id="modal-connect-api">
		          	<div className="copy-display">
						<div className="container-copy">
							<input 
							 disabled={ true }
							 value={ this.state.bearer_token }
							/>
							<CopyToClipboard text={ this.state.bearer_token } onCopy={ () => {
								this.setState({ copied: true },() => {
									setTimeout(() => {
										this.setState({ copied: false });
									},1500);
								});
							} }>
								<img src={ CopyIcon } />
							</CopyToClipboard>
						</div>
						<button className="btn-regenerate" onClick={ () => this.generateToken() }>
							Regenerar
						</button>
					</div>
				
					{
						this.state.copied && (
							<p className="copied">Copiada al portapapeles</p>
						)
					}
		          </div>
		      	</Modal>

		      	<p className="subtitle">Conecta tus canales para que el agente responda, capture leads y agente citas.</p>

		      	<Input
					value={ this.state.form.search }
					name="search"
					placeholder="Buscar integraciones"
					className="input-table"
					onSubmit={ () => this.load() }
					searchLeft={ true }
					onChange={ (e: any) => {
						this.change(e); 
					} } />

				<div className="row">
					{ ("Whatsapp".toLowerCase().search(Globals.clean(searchFilter)) != -1) && (
							<div className="col-md-6">
								<div className="container-social whatsapp">
									<div style={{ display: 'flex' }}>
										<img src={ WhatsappIcon2 } className="icon-social" />
										<div>
											<h3>Whatsapp</h3>
											<p className="description">Optimiza tu atención conectando un número exclusivo para responder a todos tus clientes desde un solo lugar.</p>
										</div>
									</div>
									<div className="container-btn">
										<div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
											<div className={ `icon-connect ${ person?.facebook_phone_id != null ? 'active' : '' }` }></div>
											<p>{ person?.facebook_phone_id != null ? 'Conectado' : 'No conectado' }</p>
										</div>
										<button className="btn" onClick={ () => person?.facebook_phone_id != null ? this.disconnect(TYPES.WHATSAPP) : this.connect(TYPES.WHATSAPP) }>
											{ person?.facebook_phone_id != null ? 'Desconectar' : 'Conectar' }
										</button>
									</div>
								</div>
							</div>
						)
					}
					{ ("Instagram".toLowerCase().search(Globals.clean(searchFilter)) != -1) && (
							<div className="col-md-6">
								<div className="container-social instagram">
									<div style={{ display: 'flex' }}>
										<img src={ InstagramIcon2 } className="icon-social" />
										<div>
											<h3>Instagram</h3>
											<p className="description">Automatiza las respuestas de tus mensajes directos (DM) de forma ágil y eficiente.</p>
										</div>
									</div>
									<div className="container-btn">
										<div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
											<div className={ `icon-connect ${ person?.instagram_token != null ? 'active' : '' }` }></div>
											<p>{ person?.instagram_token != null ? 'Conectado' : 'No conectado' }</p>
										</div>
										<button className="btn" onClick={ () => person?.instagram_token != null ? this.disconnect(TYPES.INSTAGRAM) : this.connect(TYPES.INSTAGRAM) }>
											{ person?.instagram_token != null ? 'Desconectar' : 'Conectar' }
										</button>
									</div>
								</div>
							</div>
						)
					}
					{ ("Facebook".toLowerCase().search(Globals.clean(searchFilter)) != -1) && (
							<div className="col-md-6">
								<div className="container-social facebook">
									<div style={{ display: 'flex' }}>
										<img src={ FacebookMessengerIcon2 } className="icon-social" />
										<div>
											<h3>Facebook</h3>
											<p className="description">Gestiona y automatiza las respuestas de Messenger para interactuar rápidamente con tus clientes.</p>
										</div>
									</div>
									<div className="container-btn">
										<div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
											<div className={ `icon-connect ${ person?.facebook_token != null ? 'active' : '' }` }></div>
											<p>{ person?.facebook_token != null ? 'Conectado' : 'No conectado' }</p>
										</div>
										<button className="btn" onClick={ () => person?.facebook_token != null ? this.disconnect(TYPES.FACEBOOK) : this.connect(TYPES.FACEBOOK) }>
											{ person?.facebook_token != null ? 'Desconectar' : 'Conectar' }
										</button>
									</div>
								</div>
							</div>
						)
					}
					{ ("API / Developers".toLowerCase().search(Globals.clean(searchFilter)) != -1) && (
							<div className="col-md-6">
								<div className="container-social api">
									<div style={{ display: 'flex' }}>
										<img src={ ApiIcon2 } className="icon-social" />
										<div>
											<h3>API / Developers</h3>
											<p className="description">Integra vía endpoints y webhooks</p>
										</div>
									</div>
									<div className="container-btn">
										<div style={{ display: 'flex', flex: 1, alignItems: 'center' }}></div>
										<button className="btn" onClick={ () => this.showApi() }>
											Conectar
										</button>
									</div>
								</div>
							</div>
						)
					}
				</div>

				{ ("Google Calendar".toLowerCase().search(Globals.clean(searchFilter)) != -1) && (
						<>
							<HeaderTitle title="Integraciones opcionales" />
							<p className="subtitle">Activalas solo si usarás reservas y agenda.</p>

							<div className="row">
								<div className="col-md-6">
									<GoogleCalendarButton
										load={ () => this.load(true) }
										person={ person }
										google_calendar_email={ this.state.google_calendar_email }
									/>
								</div>
							</div>
						</>
					)
				}
			</div>
		)
	}
}

const GoogleCalendarButton = (params: any) => {
	const login = useGoogleLogin({
	  onSuccess: async tokenResponse => {
	  	await ApiIntegrationService.connectGoogleCalendar({
	  		code: tokenResponse.code
	  	});
	  	Globals.showSuccess("Se ha conectado Google Calendar correctamente");
	    params?.load();
	  },
	  onError: (error) => {
	      console.error(error);
	  },
	  flow: 'auth-code',
	  scope: 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
	});

	const logout = () => {
		Globals.confirm('¿Desconectar Google Calendar?',async () => {
		  await ApiIntegrationService.deleteGoogleCalendar();
	      Globals.showSuccess("Se ha desconectado Google Calendar correctamente");
	      params?.load();
		});		
	}

	return (
		<>
			<div className="container-social google-calendar">
				<div style={{ display: 'flex' }}>
					<img src={ GoogleCalendarIcon2 } className="icon-social" />
					<div>
						<h3>Google Calendar</h3>
						<p className="description">Integración con IA para la lectura de disponibilidad, reserva automática y confirmación inteligente de citas sin intervención manual.</p>
					</div>
				</div>
				<div className="container-btn">
					<div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
						<div className={ `icon-connect ${ params?.person?.google_calendar_token != null ? 'active' : '' }` }></div>
						<p>{ params?.person?.google_calendar_token != null ? 'Conectado' : 'No conectado' }</p>
					</div>
					<button className="btn" onClick={ () => params?.person?.google_calendar_token != null ? logout() : login() }>
						{ params?.person?.google_calendar_token != null ? 'Desconectar' : 'Conectar' }
					</button>
				</div>
			</div>
		</>
	)
}

export default connect((state: RootState) => {
	return {
		user: state.user,
		access_token: state.access_token
	}
})(Api);